export default __webpack_public_path__ + "static/media/MetaMask.df996025.svg";